(function () {
  'use strict';
  if (window.PGUKRewardsProductV146Installed) return;
  window.PGUKRewardsProductV146Installed = true;
  var snapshot = null, sequence = 0;
  var country = String(window.PGRewardV101&&window.PGRewardV101.country||window.Shopify&&window.Shopify.country||'GB').toUpperCase();
  var us = country==='US', sym=us?'$':'\u00a3',tier1=us?9800:7500,tier2=us?12400:9500;
  function label1(){return sym+(us?'98':'75')}
  function label2(){return sym+(us?'124':'95')}
  function format(n) { return sym + (n / 100).toFixed(n % 100 ? 2 : 0); }
  function allowed() { return !/digital|gift-card|first-in-line|express|onward|protection|shipping/i.test(String(location.pathname || '')); }
  function amount(c) {
    if (!c || c.currency !== (us?'USD':'GBP')) return null;
    var engine = window.PGRewardEngineV101;
    if (!engine || typeof engine.qualifyingSpend !== 'function') return null;
    var n = engine.qualifyingSpend(c);
    return Number.isSafeInteger(n) && n >= 0 ? n : null;
  }

  /* UK reward badge, separate from the historic free-mug campaign. */
  function ensureGalleryGiftBadgeV146(){
    var path=String(window.location.pathname||'').toLowerCase();
    if(path.indexOf('/products/')<0||!allowed())return;
    var host=document.querySelector('.product__images');
    var gallery=host&&host.querySelector('.product_gallery, [data-product-gallery]');
    if(!host)return;
    host.classList.add('pg-v146-gift-badge-host');
    var button=host.querySelector('.pg-v146-free-gifts-gallery');
    if(!button){
      button=document.createElement('button');
      button.className='pg-v146-free-gifts-gallery';
      button.type='button';
      button.setAttribute('aria-label','Free gifts from ' + label1() + ': details');
      button.setAttribute('aria-haspopup','dialog');
      button.setAttribute('aria-controls','pg-v146-free-gifts-dialog');
      button.innerHTML='<svg viewBox="0 0 24 24" width="23" height="23" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="9" width="16" height="12" rx="2"/><path d="M3 9h18M12 9v12M12 9c-3 0-6-2-6-4s2-3 3.5-2C11 4 12 6.5 12 9Zm0 0c3 0 6-2 6-4s-2-3-3.5-2C13 4 12 6.5 12 9Z"/></svg><span>Free gifts</span><small>' + label1() + '+</small>';
      host.appendChild(button);
      button.addEventListener('click',function(){
        var dialog=document.getElementById('pg-v146-free-gifts-dialog');
        if(!dialog){
          dialog=document.createElement('div');
          dialog.className='pg-v146-free-gifts-dialog';
          dialog.id='pg-v146-free-gifts-dialog';
          dialog.hidden=true;
          dialog.innerHTML='<div class="pg-v146-free-gifts-dialog__backdrop" data-pg-free-gift-close></div>'+
          '<section class="pg-v146-free-gifts-dialog__panel" role="dialog" aria-modal="true" aria-labelledby="pg-v146-free-gift-title">'+
          '<button type="button" class="pg-v146-free-gifts-dialog__close" data-pg-free-gift-close aria-label="Close">×</button>'+
          '<p class="pg-v146-free-gifts-dialog__eyebrow">A little extra, on us</p>'+
          '<h2 id="pg-v146-free-gift-title">Free gifts from ' + label1() + '</h2>'+
          '<p>Spend ' + label1() + ' on qualifying physical products after discounts for a matching digital copy plus First in Line Artwork.</p>'+
          '<p class="pg-v146-free-gifts-dialog__pending">Reach ' + label2() + ' in qualifying physical spend to claim one free unframed A5 print of your approved portrait in the basket.</p>'+
          '<p class="pg-v146-free-gifts-dialog__small">First in Line is priority artwork preparation, not express shipping.</p></section>';
          document.body.appendChild(dialog);
          dialog.querySelectorAll('[data-pg-free-gift-close]').forEach(function(close){
            close.addEventListener('click',function(){
              dialog.hidden=true;
              document.body.classList.remove('pg-v146-free-gifts-open');
              button.focus();
            });
          });
          document.addEventListener('keydown',function(e){
            if(e.key==='Escape'&&!dialog.hidden){
              dialog.hidden=true;
              document.body.classList.remove('pg-v146-free-gifts-open');
              button.focus();
            }
          });
        }
        dialog.hidden=false;
        document.body.classList.add('pg-v146-free-gifts-open');
        dialog.querySelector('.pg-v146-free-gifts-dialog__close').focus();
      });
    }
    var h=host.getBoundingClientRect(),g=(gallery||host).getBoundingClientRect();
    if(g.width&&g.height){
      var pad=window.innerWidth<=798?12:16;
      var height=button.getBoundingClientRect().height||84;
      var bottom=Math.max(pad,g.bottom-h.top-height-pad);
      button.style.top=Math.round(bottom)+'px';
      button.style.right=Math.max(pad,h.right-g.right+pad)+'px';
    }
  }

  function boot() {
    if (!allowed()) return;
    ensureGalleryGiftBadgeV146();
    var host = document.querySelector('[data-product-form]');
    if (!host || host.querySelector('.pg-uk-rewards-v146-finish')) return;
    var progress = host.querySelector('.pg-cfg-progress'), footer = host.querySelector('.pg-cfg-footer');
    if (!progress || !footer) return;
    var badge = document.createElement('div');
    badge.className = 'pg-uk-rewards-v146-badge';
    badge.textContent = 'FREE GIFTS FROM ' + label1() + '';
    progress.parentNode.insertBefore(badge, progress);
    var panel = document.createElement('section');
    panel.className = 'pg-uk-rewards-v146-finish';
    panel.hidden = true;
    panel.innerHTML = '<strong>A little extra, on us.</strong><p><b>Spend ' + label1() + ':</b> Free digital copy and First in Line Artwork.</p><p><b>Spend ' + label2() + ':</b> Add one complimentary unframed A5 print.</p><small>Qualifying physical-product spend after discounts. One chosen artwork for the digital file and A5 print; one priority entitlement per order. Express shipping is separate.</small><p class="pg-uk-rewards-v146-finish__status" aria-live="polite"></p>';
    footer.parentNode.insertBefore(panel, footer);
    var status = panel.querySelector('.pg-uk-rewards-v146-finish__status');
    function render(c) {
      var n = amount(c);
      if (n === null) {
        status.textContent = 'Your final discounted basket determines eligibility. Rewards are confirmed in the cart.';
      } else if (n < tier1) {
        status.textContent = 'Current basket: ' + format(n) + '. ' + format(tier1 - n) + ' more unlocks your free digital copy and priority artwork.';
      } else if (n < tier2) {
        status.textContent = 'Digital copy and priority unlocked. Add ' + format(tier2 - n) + ' more for your free A5 print.';
      } else {
        var id = Number(window.PGRewardV101 && window.PGRewardV101.a5VariantId || 0);
        var included = id > 0 && (c.items || []).some(function (line) {
          return Number(line.variant_id) === id && line.quantity === 1 && Number(line.final_line_price) === 0;
        });
        status.textContent = included ? 'A5 print included free. Check your digital copy and priority benefits in the cart.' : id <= 0 ? 'Your basket has reached the ' + label2() + ' tier. A5 print is available in your basket.' : 'Your free A5 print is unlocked, not yet added. Choose your portrait and add it free in the cart.';
      }
    }
    function showStep(label) { panel.hidden = !/finish/i.test(String(label || '')); }
    document.addEventListener('pg-cfg-step', function (event) { showStep(event.detail && event.detail.label); });
    document.addEventListener('pg:cart-synchronised', function (event) {
      if (!event.detail || !event.detail.cart) return;
      sequence += 1;
      snapshot = event.detail.cart;
      render(snapshot);
    });
    var active = progress.querySelector('.pg-cfg-step-dot.is-active .pg-cfg-step-dot__label');
    showStep(active && active.textContent);
    if (snapshot) render(snapshot);
    else {
      var requestNumber = ++sequence;
      fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/') + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
        .then(function (response) { if (!response.ok) throw new Error('Cart read failed'); return response.json(); })
        .then(function (cart) { if (requestNumber === sequence) { snapshot = cart; render(cart); } })
        .catch(function () { if (requestNumber === sequence) render(null); });
    }
  }
  function bootWithGalleryRetry() {
    boot();
    [450, 1400, 3400, 6200].forEach(function(delay){
      window.setTimeout(ensureGalleryGiftBadgeV146, delay);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootWithGalleryRetry, { once: true });
  else bootWithGalleryRetry();
  document.addEventListener('shopify:section:load', bootWithGalleryRetry);
  window.addEventListener('resize',ensureGalleryGiftBadgeV146,{passive:true});
  window.addEventListener('load',ensureGalleryGiftBadgeV146,{once:true});
})();